export const types = {
  loadList: "[Courses] Load list",
  loadMyList: "[Courses] Load my list",

  addToCart: "[Courses] Add to Cart",
  removeFromCart: "[Courses] Remove from Cart",
  cleanCart: "[Courses] Clean Cart",
  reset: "[Courses] RESET",
};
